// Brand-only footer, shown on every authed screen.
//
// The Razorpay policy-link footer (`LegalFooter`) and the GSTIN legal line that
// used to live here are gone: this is an internal booking tool, not the public
// merchant site, so the crawlable policy pages moved to the public site that the
// Razorpay merchant URL points at.

/** Brand-only footer — no policy links. */
export function BrandFooter() {
  return (
    <footer className="wb-footer wb-footer--brand">
      <div className="wb-footer-brand">
        <img src="/weebee-bee.png" alt="" />
        <span className="wb-footer-legal">WayQ Tickets — internal booking tool</span>
      </div>
    </footer>
  );
}
